var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hlt-text',{staticClass:"asset-page-footer-meta-component",attrs:{"size":'sm',"variant":'content-secondary'}},[(_vm.formattedViews)?[_vm._v("\n    "+_vm._s(_vm.formattedViews.toLocaleString())+" Views ·\n  ")]:_vm._e(),_vm._v(_vm._s(_vm.asset.createdAtText)+"\n")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }